import { Option } from './types';

export const OPTIONS: Option[] = [
  { value: 'daily', label: 'daily breakdown' },
  { value: 'episode', label: 'episode breakdown' },
];
